import React from 'react';
import { NotificationSC } from './common.styles';

export const Notification = ({ children, isError }) => {
  return <NotificationSC isError={isError}>{children}</NotificationSC>;
};
